import React from 'react'

export interface RadioItem {
  label: string
}

export interface RadioGroupProps {
  collection: RadioItem[]
  name: string
  direction?: 'horizontal' | 'vertical'
  checked: number
  label?: string
  callback: (index: number) => void
  className?: string
  labelClassName?: string
}

export const RadioGroup: React.FC<RadioGroupProps> = ({
  collection,
  name,
  direction,
  checked,
  label,
  callback,
  className,
  labelClassName,
}) => {
  const layoutClass = direction === 'horizontal' ? 'flex-row' : 'flex-col'
  const groupLabel = label ?? ''
  const groupLabelClass = groupLabel === '' ? '' : 'font-semibold mb-2'
  const myLabelClassName = labelClassName ?? 'text-gray-700'

  return (
    <div className="flex-col">
      <div className={groupLabelClass}>{groupLabel}</div>
      <div className={`flex ${layoutClass} `}>
        {collection.map((item, index) => (
          <div key={`${index}_${name}`} className={`${className ?? 'flex items-center space-x-2 mr-10'}`}>
            <input
              type="radio"
              id={`${index}_${name}`}
              name={name}
              checked={checked === index}
              onChange={() => callback(index)}
              className="form-radio h-4 w-4 text-blue-600 "
            />
            <label htmlFor={`${index}_${name}`} className={myLabelClassName}>
              {item.label}
            </label>
          </div>
        ))}
      </div>
    </div>
  )
}

// Permite que el ordenamiento de los "radio" se haga desde afuera
export const RadioGroupEx: React.FC<RadioGroupProps> = ({
  collection,
  name,
  checked,
  callback,
  className,
  labelClassName,
}) => {
  const myLabelClassName = labelClassName ?? 'text-gray-700'

  return (
    <>
      {collection.map((item, index) => (
        <div key={`${index}_${name}`} className={`${className ?? 'flex items-center space-x-2 mr-10'}`}>
          <input
            type="radio"
            id={`${index}_${name}`}
            name={name}
            checked={checked === index}
            onChange={() => callback(index)}
            className="form-radio h-4 w-4 text-blue-600 "
          />
          <label htmlFor={`${index}_${name}`} className={myLabelClassName}>
            {item.label}
          </label>
        </div>
      ))}
    </>
  )
}
